module.exports = __webpack_public_path__ + "static/media/201CS132.9b0ca248.jpg";